import { jsx } from 'react/jsx-runtime';

const sizeMap = {
    large: 32,
    medium: 24,
    small: 16,
};
const SvgArrowDownOutlined = (props) => (jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: sizeMap[props.size || "medium"], height: sizeMap[props.size || "medium"], fill: "none", viewBox: "0 0 24 24" }, props, { children: jsx("path", { fill: props.color || "currentColor", fillRule: "evenodd", d: "M12 4a1 1 0 0 1 1 1v11.586l5.293-5.293a1 1 0 0 1 1.414 1.414l-7 7a1 1 0 0 1-1.414 0l-7-7a1 1 0 1 1 1.414-1.414L11 16.586V5a1 1 0 0 1 1-1", clipRule: "evenodd" }) })));

export { SvgArrowDownOutlined as default };
